import React from 'react';

import style from './style.module.scss';

import '@material/web/menu/menu-item.js';

export type MenuItemType = 'menuitem' | 'option' | 'button' | 'link';

export interface MenuItemProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  icon?: React.ReactElement<any>;
  trailingIcon?: React.ReactElement<any>;
  disabled?: boolean;
  selected?: boolean;
  keepOpen?: boolean;
  type?: MenuItemType;
  href?: string;
  target?: '_blank' | '_parent' | '_self' | '_top' | '';
}

const MenuItem: React.FC<MenuItemProps> = ({
  children,
  icon,
  trailingIcon,
  disabled = false,
  selected = false,
  keepOpen = false,
  type = 'menuitem',
  href,
  target,
  className = '',
  ...htmlAttributes
}) => {
  const classes = [style.menuItem, className]
    .filter(Boolean)
    .join(' ');

  const materialProperties: { [key: string]: any } = {
    ...htmlAttributes,
    class: classes,
    type: href ? 'link' : type,
  };

  if (disabled) {
    materialProperties.disabled = '';
  }

  if (selected) {
    materialProperties.selected = '';
  }

  if (keepOpen) {
    materialProperties['keep-open'] = '';
  }

  if (href !== undefined) {
    materialProperties.href = href;
  }

  if (target !== undefined) {
    materialProperties.target = target;
  }

  const slottedIcon = icon
    ? React.cloneElement(icon, {
        key: 'leading-icon',
        slot: 'start',
        className: [style.menuItemIcon, icon.props.className]
          .filter(Boolean)
          .join(' '),
        'aria-hidden': icon.props['aria-label'] ? undefined : true,
      })
    : null;

  const slottedTrailingIcon = trailingIcon
    ? React.cloneElement(trailingIcon, {
        key: 'trailing-icon',
        slot: 'end',
        className: [
          style.menuItemIcon,
          trailingIcon.props.className,
        ]
          .filter(Boolean)
          .join(' '),
        'aria-hidden': trailingIcon.props['aria-label'] ? undefined : true,
      })
    : null;

  return React.createElement(
    'md-menu-item',
    materialProperties,
    slottedIcon,
    React.createElement(
      'span',
      {
        className: `pgm-label-large ${style.menuItemLabel}`,
        slot: 'headline',
      },
      children,
    ),
    slottedTrailingIcon,
  );
};

export default MenuItem;
